import { Record, Set, Map } from 'immutable';
import { INodeData, INodeDataAttributes } from '../connector';
import { DataModelState, RecordFactory, RequestDiffRecord } from '../shared';

const nodeDataStateRecord = Record({
  ids: Set<string>(),
  entities: Map<string, NodeData>(),
  relationships: Map<string, NodeDataRelationships>(),
  diff: new RequestDiffRecord(),
  isBusy: 0
});

export class NodeDataState extends nodeDataStateRecord implements DataModelState {
  ids: Set<string>;
  entities: Map<string, NodeData>;
  relationships: Map<string, NodeDataRelationships>;
  diff: RequestDiffRecord;
  isBusy: number;
}

const nodeDataRecord = Record(<INodeDataAttributes>{
  id: undefined,
  name: '',
  reference: '',
  crossReference: '',
  createdAt: undefined,
  description: '',
  description1: '',
  description2: '',
  description3: '',
  description4: '',
  documentUri: '',
  upload_uri: '',
  status: 0,
  responsibleId: null,
  groupId: undefined,
  targetDate: null,
  actualDate: null,
  businessBenefit: 0,
  commercialStatus: 0,
  complexity: 0,
  uncertainty: 0,
  risk: 0,
  sizeType: 0,
  budget: 0,
  budgetCalculated: 0,
  budgetActual: 0,
  budgetRemaining: 0,
  benefitBudget: 0,
  benefitActual: 0,
  benefitRemaining: 0,
  costBudget: 0,
  costActual: 0,
  costRemaining: 0,
  investBudget: 0,
  investActual: 0,
  investRemaining: 0,
  businesscalculation: null,
  duplicate_original_id: undefined,
  onreport: true,
  storypoints: 0,
  costtype: 0,
  nodeType: 0,
  sync: undefined,

  startDate: null,
  actualStartDate: undefined,
  percentageComplete: undefined,
  priority: undefined,

  riskProfileCategory: undefined,
  riskProfileAssessment: undefined,
  riskProfileCountermeasures: '',
  time: 0,
  timeDescription: '',
  cost: 0,
  costDescription: '',
  quality: 0,
  qualityDescription: '',
  executive: 0,
  executiveDescription: '',
  program: 0,
  programDescription: '',
  functional: 0,
  functionalDescription: '',
  resource: 0,
  resourceDescription: '',
  organizational: 0,
  organizationalDescription: '',
  technical: 0,
  technicalDescription: '',
  updatedAt: undefined,

  creationDate: undefined,
  lastUpdated: undefined,
  currency: '',

  alsoPublishedAs: '',
  cpc: '',
  cpc4: '',
  ipc: '',
  ipc4: '',
  applicants: '',
  techAreas: '',
  techFields: '',
  authorities: '',

  color: '',
  widget: '',
  icon: '',
  obligatory: false,

  workFlowModel: 0,
  workFlowOperation: '',
  workFlowIfClause: '',
  workFlowId: '',
  workFlowFormId: '',
  workFlowFormParams: '',
  workFlowLink: '',
  workFlowTabId: '',

  formId: '',
  formFieldId: '',
  formFieldType: '',
  formFieldControlType: '',
  formFieldDropdownValue: '',
  formFieldCalculation: '',
  formFieldEditable: false,
  formFieldSortable: true,
  formFieldFilterable: false,
  formFieldFixed: false,
  formFieldSearchable: false,
  formFieldWidth: null,
  formFieldShape: '',
  formFieldBucketId: '',
  formBucket: false,
  form_default_value: '',
  dashboardCols: null,
  dashboardRows: null,
  dashboardX: null,
  dashboardY: null,
  fieldConversion: null,
  fieldCreateType: null,
  fieldSkipIfExists: false,
  colorLabelProvider: null,

  fullscreen: false,
  printable: false,
  hideWidget: false,

  ai_type: '',
  ai_preset: '',

  relationships: undefined
});

export class NodeData extends nodeDataRecord implements INodeDataAttributes {
  id: string;
  name: string;
  reference: string;
  crossReference: string;
  createdAt: number;
  description: string;
  description1: string;
  description2: string;
  description3: string;
  description4: string;
  documentUri: string;
  upload_uri: string;
  status: number;
  responsibleId: number;
  groupId: number;
  targetDate: string;
  actualDate: string;
  businessBenefit: number;
  commercialStatus: number;
  complexity: number;
  uncertainty: number;
  risk: number;
  sizeType: number;
  budget: number;
  budgetCalculated: number;
  budgetActual: number;
  budgetRemaining: number;
  benefitBudget: number;
  benefitActual: number;
  benefitRemaining: number;
  costBudget: number;
  costActual: number;
  costRemaining: number;
  investBudget: number;
  investActual: number;
  investRemaining: number;
  businesscalculation: string;
  duplicate_original_id?: number;
  onreport: boolean;
  storypoints: number;
  costtype: number;
  nodeType: number;
  sync?: any;

  startDate?: string;
  actualStartDate?: string;
  percentageComplete?: number;
  priority?: number;

  riskProfileCategory?: number;
  riskProfileAssessment?: number;
  riskProfileCountermeasures?: string;
  time?: number;
  timeDescription?: string;
  cost?: number;
  costDescription?: string;
  quality?: number;
  qualityDescription?: string;
  executive?: number;
  executiveDescription?: string;
  program?: number;
  programDescription?: string;
  functional?: number;
  functionalDescription?: string;
  resource?: number;
  resourceDescription?: string;
  organizational?: number;
  organizationalDescription?: string;
  technical?: number;
  technicalDescription?: string;

  updatedAt: number;

  creationDate: number;
  lastUpdated: number;
  currency: string;

  alsoPublishedAs?: string;
  cpc?: string;
  cpc4?: string;
  ipc?: string;
  ipc4?: string;
  applicants?: string;
  techAreas?: string;
  techFields?: string;
  authorities?: string;

  color?: string;
  widget?: string;
  icon?: string;
  obligatory?: boolean;

  workFlowModel?: number;
  workFlowOperation?: string;
  workFlowIfClause?: string;
  workFlowId?: string;
  workFlowFormId?: string;
  workFlowFormParams?: string;
  workFlowLink?: string;
  workFlowTabId?: string;

  formId: string;
  formFieldId: string;
  formFieldType: string;
  formFieldControlType: string;
  formFieldDropdownValue: string;
  formFieldEditable: boolean;
  formFieldSortable: boolean;
  formFieldFilterable: boolean;
  formFieldFixed: boolean;
  formFieldSearchable: boolean;
  formFieldWidth: string;
  formFieldBucketId: string;
  formFieldShape: string;
  formBucket: boolean;
  formFieldCalculation: string;
  form_default_value: string | number;

  dashboardCols: number;
  dashboardRows: number;
  dashboardX: number;
  dashboardY: number;

  fieldConversion: string;
  fieldCreateType: string;
  fieldSkipIfExists: boolean;
  colorLabelProvider: string;

  fullscreen: boolean;
  printable: boolean;
  hideWidget: boolean;

  ai_type: string;
  ai_preset: string;

  relationships: NodeDataRelationships;

  static fromJSONAPI(nodedata: INodeData) {
    return RecordFactory.entity.fromJSONAPI<NodeData>(NodeData, nodedata);
  }
}

const relationshipsRecord = Record({
  activities: undefined,
  businessarea: undefined,
  instance: undefined,
  models: undefined,
  nodestructures: undefined,
  created: undefined,
  relatedChildren: Set<number>(),
  relatedParents: Set<number>()
});

export class NodeDataRelationships extends relationshipsRecord {
  activities: string[];
  models: string[];
  nodestructures: string[];
  businessarea: string;
  instance: string;
  created: string[];
  relatedChildren: number[] | Set<number>;
  relatedParents: number[] | Set<number>;

  static fromJSONAPI(nodedata: INodeData) {
    return RecordFactory.relationships.fromJSONAPI<NodeDataRelationships>(NodeDataRelationships, nodedata);
  }
}
